export function GenerationNotification() {
  return (
    <div className="border-cta-gradient mt-2 flex items-center gap-4 rounded-lg bg-white px-4 py-3">
      <div className="flex-shrink-0">
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.9999 4.00001C9.3725 4.00001 3.99992 9.37259 3.99992 16C3.99992 22.6274 9.3725 28 15.9999 28C22.6273 28 27.9999 22.6274 27.9999 16C27.9999 9.37259 22.6273 4.00001 15.9999 4.00001ZM1.33325 16C1.33325 7.89983 7.89974 1.33334 15.9999 1.33334C24.1001 1.33334 30.6666 7.89983 30.6666 16C30.6666 24.1002 24.1001 30.6667 15.9999 30.6667C7.89974 30.6667 1.33325 24.1002 1.33325 16ZM14.6666 10.6667C14.6666 9.9303 15.2635 9.33334 15.9999 9.33334H16.0133C16.7496 9.33334 17.3466 9.9303 17.3466 10.6667C17.3466 11.4031 16.7496 12 16.0133 12H15.9999C15.2635 12 14.6666 11.4031 14.6666 10.6667ZM15.9999 14.6667C16.7363 14.6667 17.3333 15.2636 17.3333 16V21.3333C17.3333 22.0697 16.7363 22.6667 15.9999 22.6667C15.2635 22.6667 14.6666 22.0697 14.6666 21.3333V16C14.6666 15.2636 15.2635 14.6667 15.9999 14.6667Z"
            fill="url(#paint0_linear_8323_658)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_8323_658"
              x1="1.77003"
              y1="-17.1136"
              x2="31.7811"
              y2="-16.403"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.062" stopColor="#AD46FF" />
              <stop offset="1" stopColor="#155DFC" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <p className="text-sm font-normal text-gray-700">
        From the generated designs, you can hover over the design you like and edit it further.
      </p>
    </div>
  );
}
